import type { NextPage } from 'next';
import PageHead from '@atoms/page-head/page-head';
import { useEffect } from 'react';
import { useLayout } from '@context/layout-context';
import { redirectToVendorsLogin } from '@utils/helpers';

const VendorCredentials: NextPage = () => {
  const { setIsLoading } = useLayout();

  useEffect(() => {
    setIsLoading(true);
    redirectToVendorsLogin();
  }, [setIsLoading]);

  return (
    <>
      <PageHead title="Login" />
    </>
  );
};

export default VendorCredentials;
